import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakingLive, BrakingLiveRequest } from 'src/app/models/breaking-live';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BreakingLiveService {
  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private http: HttpClient) {}

  saveAlarm(data: BrakingLiveRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/request?event=guardar-alarma`, data, { headers: { 'Content-Type': 'application/json' }});
  }

  getCurrentStatus(): Promise<BreakingLive> {
    const random = Date.now();
    const url = `https://s3-us-west-2.amazonaws.com/filesstaticpulzo/pulzo-lite/jsons/admin/alertas_ultima_hora_en_vivo.json?nocache=${random}`;
    
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar');
        return res.json();
      })
      .then(data => {
        console.log('Datos cargados del JSON:', data);
        return data;
      });
  }
  

  getArticleData(articleUrl): Promise<any> {
    return fetch(articleUrl)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar secciones');
        return res.json();
      });
  }
}